import { useState, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { ArrowLeftStartOnRectangleIcon } from "@heroicons/react/20/solid";
import { useLocation, useMatch, useNavigate } from "react-router";
import * as React from "react";
import { Icon } from "@iconify/react";
import LogoutModal from "./LogoutModal";
import { useAuthStore } from "../../../store/useAuthStore";
import useIsMobile from "../../../utils/detectDevice";
import { HStack, VStack } from "../../../components/utils";
import Avatar from "./Avatar";
import { useUserDetails, useUserDetailsV2 } from "../../../queries";

export function FlyoutProfile({ profilePicUrl }: { profilePicUrl: string }) {
  const [dialogLogout, setDialogLogout] = useState(false);
  const [show, setShown] = useState(false);
  const [dialogChangePassword, setDialogChangePassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { isMobile } = useIsMobile(1025);

  const navigate = useNavigate();

  const contextRef = React.useRef<HTMLDivElement>(null);
  const contextRef2 = React.useRef<HTMLDivElement>(null);
  const { setAuth, user, clear } = useAuthStore();
  const { data: userProfileDetails } = useUserDetailsV2();
  const [loading, setLoading] = useState(false);

  const fullName =
    (userProfileDetails as any)?.full_name ??
    userProfileDetails?.fullName ??
    "";
  const emailId =
    (userProfileDetails as any)?.email_id ??
    userProfileDetails?.emailId ??
    (userProfileDetails as any)?.email ??
    "";

  const routes = [
    {
      name: "Log Out",
      onClick: () => {
        setDialogLogout(true);
        setShown(false);
      },
      type: "heroIcon",
      icon: ArrowLeftStartOnRectangleIcon,
    },
  ];

  const profileMatch = useMatch(`/${"/user/profile".split("/")[1]}/*`);
  const { pathname } = useLocation();

  return (
    <div>
      {loading ? (
        <div className="items-center px-6 py-2">
          <p className="text-sm animate-pulse font-medium">Switching...</p>
        </div>
      ) : (
        <Popover className="relative">
          {dialogLogout && (
            <LogoutModal
              isOpen={dialogLogout}
              onClose={() => {
                setDialogLogout(false);
              }}
            />
          )}
          {/* TODO: need to navigate to Change Password Page */}
          <Popover className="relative">
            <div>
              <Popover.Button
                onClick={() => setShown(!show)}
                onMouseEnter={() => {
                  setShown(true);
                }}
                onMouseLeave={() => {
                  setShown(false);
                }}
                className={`-ml-1.5 flex gap-2 cursor-pointer items-center p-1  ${
                  pathname !== "/profile"
                    ? "bg-white text-secondary"
                    : "bg-secondary text-white"
                } `}
              >
                <div className="flex items-center justify-center flex-none mt-1 rounded-lg h-11 w-11 bg-gray-50 group-hover:bg-white">
                  <Avatar name={fullName || ""} profilePicUrl={profilePicUrl} />
                </div>
              </Popover.Button>
            </div>
            <Transition
              show={show}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                onMouseEnter={() => {
                  setShown(true);
                }}
                onMouseLeave={() => {
                  setShown(false);
                }}
                ref={contextRef}
                className="absolute z-10 mt-5 flex w-screen max-w-max  right-0 "
              >
                <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-lg bg-white text-sm leading-6 shadow-lg">
                  <div className="divide-x divide-gray-900/5 bg-gray-50">
                    <div className="group relative flex gap-x-2 rounded-lg p-4 hover:bg-gray-50">
                      <div className="flex items-center justify-center flex-none mt-1 rounded-lg h-11 w-11 bg-gray-50 group-hover:bg-white">
                        <Avatar
                          name={fullName || ""}
                          profilePicUrl={profilePicUrl}
                        />
                      </div>
                      <VStack className="w-full">
                        <HStack className="justify-between items-center w-full">
                          <a className="font-semibold text-gray-900 flex-1">
                            {fullName}
                            <span className="absolute inset-0" />
                          </a>
                        </HStack>

                        <p className="text-gray-600 whitespace-nowrap">
                          {emailId}
                        </p>
                        <p className="text-sm text-gray-500 text-ellipsis overflow-clip"></p>
                      </VStack>
                    </div>
                  </div>

                  <div className="p-2  cursor-pointer">
                    {routes.map((item) => (
                      <div
                        key={item.name}
                        onClick={() => {
                          item.onClick();
                        }}
                        className="group relative flex gap-x-4 rounded-lg p-2 hover:bg-gray-50 items-center"
                      >
                        <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                          {item?.type !== "iconify" && (
                            <item.icon
                              className={`h-6 w-6 text-gray-600 group-hover:text-primary ${
                                profileMatch && item.name === "Profile"
                                  ? "text-primary"
                                  : ""
                              }`}
                              aria-hidden="true"
                            />
                          )}
                          {item?.type === "iconify" &&
                            typeof item.icon === "string" && (
                              <Icon
                                icon={item.icon || ""}
                                className={`h-6 w-6 text-gray-600 group-hover:text-primary ${
                                  profileMatch && item.name === "Profile"
                                    ? "fill-primary"
                                    : ""
                                }`}
                              />
                            )}
                        </div>
                        <div>
                          <a
                            className={`font-semibold text-gray-900 group-hover:text-primary ${
                              profileMatch && item.name === "Profile"
                                ? "text-primary"
                                : ""
                            }`}
                          >
                            {item.name}
                            <span className="absolute inset-0" />
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>
        </Popover>
      )}
    </div>
  );
}
